import React from 'react';

export default function WhatsAppButton({ message }) {
  const phoneNumber = "917010716344"; // Replace with your full WhatsApp number (no +)

  const openWhatsApp = (e) => {
    e.preventDefault(); // Prevent default <a> behavior
    const encodedMessage = encodeURIComponent(message || "Hi, I would like to know more about the product");
    const url = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(url, '_blank');
  };

  return (
    <a
      href={`https://wa.me/${phoneNumber}`} // fallback if JS is disabled
      onClick={openWhatsApp}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-5 right-5 z-50 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg hover:scale-110 transition"
    >
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M20.52 3.48A11.88 11.88 0 0012 0a11.94 11.94 0 00-10.4 17.94L0 24l6.29-1.66A11.92 11.92 0 0012 24a11.88 11.88 0 008.48-20.52zm-8.48 19.02a10.45 10.45 0 01-5.35-1.46l-.38-.23-3.74.99 1-3.63-.24-.37a10.48 10.48 0 1119.18-5.62A10.46 10.46 0 0112 22.5zm5.47-7.91c-.3-.15-1.77-.88-2.04-.98s-.47-.15-.66.15-.76.98-.93 1.18-.34.22-.63.07a8.52 8.52 0 01-2.48-1.54 9.32 9.32 0 01-1.73-2.14c-.18-.3 0-.46.13-.6.13-.13.3-.33.45-.5s.22-.26.34-.45.06-.33 0-.48-.66-1.58-.9-2.16-.48-.5-.66-.51H7.3c-.15 0-.4.05-.6.26s-.79.77-.79 1.88.82 2.18.93 2.33 1.6 2.43 3.87 3.41c.54.23.96.36 1.3.46a3.1 3.1 0 001.42.09c.43-.06 1.32-.54 1.5-1.07s.19-.98.14-1.07z" />
      </svg>
    </a>
  );
}